<adm-type-ahead-selector2
  label="Vælg afdeling"
  [required]="required()"
  [validationControl]="validationControl()"
  [requiredErrorText]="requiredErrorText()"
  [itemTemplate]="itemTemplate()"
  [fetchFn]="fetchDepartments"
  [fetchByIdFn]="fetchDepartmentById"
  [initialId]="departmentId() ?? undefined"
  (clearTypeAhead)="clearTypeAhead.emit()"
  (itemSelected)="departmentSelected($event ?? undefined)"
  identityPropertyName="id"
  [disabled]="disabled()"
  [resetTrigger]="resetTrigger()">
</adm-type-ahead-selector2>
